import { useRef } from 'react'
import styled from 'styled-components'

import { FadeOverflow, hiddenScrollbarCss } from '@root/shared/ui-kit'
import { HorizontalList } from '@root/shared/ui-kit/horizontal-list'

import { TopbarRecentSearchItem } from './topbar-recent-search-item'

import type { PairModel } from '@root/entities/pair'

type Props = {
  recentSearchPairs: Array<PairModel>
}

export const TopbarRecentSearchList = ({ recentSearchPairs }: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null)

  return (
    <HorizontalList transformScrollBehavior scrollRef={scrollRef}>
      <ListGroup ref={scrollRef}>
        {recentSearchPairs.map((pair) => (
          <TopbarRecentSearchItem key={pair.address} pair={pair} />
        ))}
      </ListGroup>
    </HorizontalList>
  )
}

const ListGroup = styled(FadeOverflow)`
  display: flex;
  width: 100%;
  padding-inline: 2px 10px;

  position: relative;
  overflow-y: hidden;

  ${hiddenScrollbarCss}

  html[data-platform='windows'] & {
    scrollbar-color: unset;
    scrollbar-width: auto;
    &::-webkit-scrollbar {
      display: block;
      height: 8px;
    }
  }
`
